import axios from "axios"
import { environment } from "../../../environments/environment"

export const getQuoteList = (page, pageSize, search, order, body) => {
    let params = new URLSearchParams();
    params.append("page", page);
    params.append("pageSize", pageSize);
    params.append("search", search);
    params.append("orderBy", order);

    return axios.post(environment.getQuotes + params, body)
}


export const getQuoteListDetails = (page, pageSize, search, order, body) => {
    let params = new URLSearchParams();
    params.append("page", page);
    params.append("pageSize", pageSize);
    params.append("search", search);
    params.append("orderBy", order);

    return axios.post(environment.getQuotesDetails + params, body)
}

export const updateRFQDetails = (body) => {
    return axios.post(environment.updateRFQ, body)
}
export const emitQuoteEntry = (body) => {
    return axios.post(environment.emitQuoteEntry , body)
}